module.exports = __webpack_public_path__ + "static/media/emailSent.c3e11567.png";